import ClearIcon from '@mui/icons-material/Clear';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputLabel,
  LinearProgress,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useContext, useEffect, useState } from 'react';

import {
  RegionType,
  emptyRegion,
  getGovernorateForDistrict,
  regions,
} from '../../../../data/regions';
import { CriticalOrderSurcharge, OrderType } from '../../../../interfaces/delivery-company/orders';

import axios, { AxiosResponse } from 'axios';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import { emptyCustomer } from '../../../../data/customers';
import { CustomerType } from '../../../../interfaces/common/customer';
import AutocompleteWithThrottle from '../../../common/autocomplete-with-throttle/autocomplete-with-throttle';
import {
  assignCustomerProvider,
  assignLocationProvider,
  assignPickupLocationProvider,
} from '../../../common/create-callbacks-utils/create-callbacks-utils';
import CreateCustomerForm from '../../../common/create-customer-form/create-customer-form';
import ConfirmAction from '../../../common/confirm-action/confirm-action';
import TextFieldWithScan from '../../../common/textfield-with-scan/textfield-with-scan';
import { emptyOrder } from '../../../delivery-company-components/orders/create-order-form/create-order-form.utils';

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AddressInputWithAutocomplete from '../../../common/adress-input-with-autocomplete/address-input-with-autocomplete';
import { ErrorsFlattenner } from '../../../common/errors-flattenner/errors-flattenner';
import Decimal from 'decimal.js';
import MoneyInput from '../../../common/money-input/money-input';
import { add, CURRENCY, displayMoney, isNonZero, minus, Money, moneyToMetric } from '../../../../utils/money';

import { get_cod, get_price } from '../../../../utils/cod';
import WeightInput from '../../../common/weight-input/weight-input';
import DimensionsInput from '../../../common/dimensions-input/dimensions-input';
import { DeliveryState, Workflow } from '../../../../enums/orders';
import { ShopLocationType } from '../../../../interfaces/delivery-company/pickups';
import InputWithLegend from '../../../common/input-with-legend/input-with-legend';
import CreatePickupLocationForm from '../../../delivery-company-components/pickup-location-form/pickup-location-form';
import MerchantCreatePickupLocationForm from '../../merchant-pickup-locations/merchant-create-pickup-form/merchant-create-pickup-form';
import { ILocation } from '../../../../interfaces/common/location';
import { isMobile, isTablet } from 'react-device-detect';
import CustomDialog from '../../../common/custom-dialog/custom-dialog';
import CreateLocationForm from '../../location-form/location-form';
import { MerchantType } from '../../../../interfaces/delivery-company/merchants';
import { useSnackBar } from '../../../../contexts/snackbar';
import CustomerWithNavigate from '../../../common/customer-with-navigate/customer-with-navigate';
import CustomerPopoverDisplay from '../../utils/customer-popover-display';
import { CustomerWithIcon } from '../../../common/styles/customer-with-icon';
import {
  Backspace,
  Clear,
  Edit,
  ExpandLess,
  ExpandMore,
  TurnedInNot,
  YouTube,
} from '@mui/icons-material';
import { LabelValueWithKey } from '../../../../interfaces/delivery-company/labels';
import LabelsInput from '../../../common/labels-input/labels-input';
import {
  calculateBaseDeliveryFee,
  calculateExtraDeliveryCharges,
  splitExtraCharges,
  updateDeliveryFee,
} from '../../../../utils/order';
import GenericTable from '../../../common/generic-table/generic-table';
import { Dayjs } from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { displayLocation } from '../../../../utils/locations';
import IncompleteAddressError from '../../../common/incomplete-address-error/incomplete-address-error';
import { IDeliveryChargeRule } from '../../../delivery-company-components/merchants/delivery-charge-rules/interfaces';
import { deliveryChargeRuleApplies } from '../../../../utils/delivery_charge_rules';
import { displayDeliveryRule } from '../../../delivery-company-components/merchants/delivery-charge-rules/utils';
import DeliveryChargeOverridesDialog from '../../../delivery-company-components/merchants/merchant-forms/delivery-charge-overrides-dialog';
import { GiCrackedGlass } from 'react-icons/gi';
import { IconWithText } from '../../../common/styles/components';
import { LocationOn as LocationOnIcon, Warning as WarningIcon } from '@mui/icons-material';
import { OrgSettingsContext } from '../../../../contexts/org-settings-context';
import { useVideoTutorial } from '../../../../contexts/video-tutorial-context/video-tutorial-context';
import TextFieldWithArabicKeyboard from '../../../common/text-field-with-arabic-keyboard';
import CriticalOrderBalanceDisplay from '../../../common/critical-order-balance-display/critical-order-balance-display';
import { CriticalOrderBalance } from '../../../../interfaces/delivery-company/orders';
import { useCriticalOrders } from '../../../../hooks/use-critical-orders';
import PackagesEditor from '../../../common/packages-editor/packages-editor';

interface MerchantCreateOrderFormProps {
  defaultOrder?: OrderType;
  onSuccess?: (order: OrderType) => void;
}

function MerchantCreateOrderForm({
  defaultOrder,
  onSuccess,
}: MerchantCreateOrderFormProps) {
  const [orderData, setOrderData] = useState<OrderType | undefined>(() => {
    if (defaultOrder != undefined) return defaultOrder;
    return emptyOrder;
  });

  const { color } = useContext(OrgSettingsContext);

  const [frozenUntil, setFrozenUntil] = useState<Dayjs | null>();

  const [workflow, setWorkflow] = useState<Workflow>(
    orderData ? orderData.workflow : Workflow.STANDARD
  );

  const { showVideoTutorial } = useVideoTutorial();

  const [creatingNewCustomerOpenFor, setCreatingNewCustomerOpenFor] =
    useState<CustomerType | null>(null);

  const [extraChargesExpanded, setExtraChargesExpanded] = useState(false);

  const setSelectedLabels = (selectedLabels: LabelValueWithKey[]) => {
    if (orderData) {
      const baseCharge = calculateBaseDeliveryFee(orderData);
      setOrderData(
        updateDeliveryFee({ ...orderData, labels: selectedLabels }, baseCharge)
      );
    }
  };

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>('');
  const [response, setResponse] = useState<AxiosResponse>();
  const [message, setMessage] = useState<string>('');
  const [cod, setCod] = useState<Money[]>(get_cod(orderData ?? emptyOrder));
  const [createPickupLocation, setCreatePickupLocation] = useState(false);
  const [createLocation, setCreateLocation] = useState(false);
  const { showMessage } = useSnackBar();
  const [isUpdatingDeliveryFees, setIsUpdatingDeliveryFees] = useState(false);
  const [explainDeliveryRule, setExplainDeliveryRule] = useState(false);

  const { user, refreshUser, config } = useContext(AuthContext);

  const canEditWorkflow = defaultOrder == undefined || defaultOrder.delivery_state == DeliveryState.CREATED
  const canEditCustomerLocation = defaultOrder == undefined || defaultOrder.delivery_state == DeliveryState.CREATED || defaultOrder.workflow == Workflow.STANDARD 
  const canEditMerchantLocation = defaultOrder == undefined || defaultOrder.delivery_state == DeliveryState.CREATED || defaultOrder.workflow == Workflow.RETURN

  const {fetchBalance, loadingBalance, balance} = useCriticalOrders();

  
  useEffect(()=>{
    if (cod && orderData?.delivery_fee && orderData.id == '' ) {
      const price = minus(cod, orderData.delivery_fee)
      setOrderData({...orderData, product_price: price.length > 0 ? price[0][1].toString() : "0"})
    }
  }, [cod])

  console.log("current user = ", user)


  const applyDeliveryFeeRules = (rules: IDeliveryChargeRule[]) => {
    if (orderData) {
      const baseCharge = calculateBaseDeliveryFee(orderData);

      const amount = rules
        .map((rule) => rule.delta_charge)
        .reduce((a, b) => a.add(b), Decimal(0));
      if (!amount.isZero()) {
        showMessage(`${amount.toString()}$ charge`, 'info');
      }
      setOrderData(
        updateDeliveryFee(
          { ...orderData, delivery_fee_rules: rules },
          baseCharge
        )
      );
    }
  };

  const clearDeliveryFeeRule = () => {
    if (orderData) {
      const baseCharge = calculateBaseDeliveryFee(orderData);
      setOrderData(
        updateDeliveryFee({ ...orderData, delivery_fee_rules: [] }, baseCharge)
      );
    }
  };

  
  useEffect(() => {
    const updateDeliveryChargeDelta = async () => {

      if (defaultOrder && defaultOrder!.customer_location!.area!.id == orderData!.customer_location!.area!.id && defaultOrder.workflow == workflow) {
          applyDeliveryFeeRules(defaultOrder.delivery_fee_rules??[])
          return
      }

      const endpoint = `${API_ENDPOINT}/v1/delta-delivery-fees/?area=${orderData!.customer_location!.area!.id}`
      try {
        setIsUpdatingDeliveryFees(true)
        const response = await axios.get<IDeliveryChargeRule[]>(endpoint, config)
        const rules = response.data.filter(item => item.id != undefined)

        rules.forEach(rule => {
          if (rule.delta_charge)
            rule.delta_charge = new Decimal(rule.delta_charge)
        })
        
        applyDeliveryFeeRules(rules)
      } catch(e) {
        console.log(e)
        showMessage("Failed to update delivery fee", 'error')
      } finally {
        setIsUpdatingDeliveryFees(false)
      }
    }

    if (!orderData || workflow != Workflow.STANDARD || !orderData.customer_location) {
      clearDeliveryFeeRule()
    } else {
      updateDeliveryChargeDelta()
    }

  }, [orderData?.customer_location, orderData?.customer_location?.area, workflow])

    useEffect(()=>{
        const updateCriticalSurcharge = async () => {
        
        let newCriticalOrderSurcharge: CriticalOrderSurcharge | undefined = undefined
  
        if (orderData?.is_critical) {
          // we should set critical order fee
          if (defaultOrder?.critical_order_surcharge) {
            newCriticalOrderSurcharge = defaultOrder.critical_order_surcharge
          } else {
            const balance = await fetchBalance()
            if (!balance) {
              showMessage("Something went wrong. Refresh and try again.", "error");
            } else {
              newCriticalOrderSurcharge = {
                method: balance.surcharge_method,
                amount: balance.estimated_surcharge
              }
            }
          }
        } 
  
        setOrderData({
          ...orderData!, 
          critical_order_surcharge: newCriticalOrderSurcharge,
          delivery_fee: add(minus(orderData?.delivery_fee??[], orderData?.critical_order_surcharge?.amount ?? []), newCriticalOrderSurcharge?.amount ?? [])
        })
        
      }
  
     
      updateCriticalSurcharge()
  
     
    }, [orderData?.is_critical])
  
  

  console.log('current order = ', JSON.stringify(orderData));
  useEffect(() => {
    const initialize = async () => {
      setIsLoading(true);
      await refreshUser();
      let defaultPickupLocation: ShopLocationType | null = null;

      // Fetch default pickup location
      try {
        const pickupResponse = await axios.get<{
          count: number;
          results: ShopLocationType[];
        }>(
          `${API_ENDPOINT}/api/v1/pickups/?page_size=1&is_default=true`,
          config
        );

        if (pickupResponse.data.results.length > 0) {
          defaultPickupLocation = pickupResponse.data.results[0];
        }
      } catch (e) {
        showMessage('Failed to get default pickup location', 'error');
      }

      if (orderData) {
        let newOrder = {
          ...orderData!,
          merchant_location:
            orderData?.merchant_location ?? defaultPickupLocation ?? null,
        };

        if (!defaultOrder)
          newOrder = updateDeliveryFee(
            newOrder,
            user?.default_delivery_fee ?? []
          );

        setOrderData(newOrder);
      }

      setIsLoading(false);
    };
    initialize();
  }, []);

  const handleFetchCustomers = async (
    query: string
  ): Promise<CustomerType[]> => {
    if (orderData) {
      const endpoint = `${API_ENDPOINT}/api/v1/customers/?page_size=10&name_or_phone=${encodeURIComponent(query)}`;

      try {
        const response = await axios.get<{
          count: number;
          results: CustomerType[];
        }>(endpoint, config);
        return response.data.results;
      } catch (error) {
        console.log(error);
      }
    }

    return [];
  };

  // Initialise data assigners to be used as success callbacks when creating entities inline
  const assignCustomer = assignCustomerProvider({
    orderData,
    setOrderData,
  });
  const assignLocation = assignLocationProvider({ orderData, setOrderData });

  const assignPickupLocation = assignPickupLocationProvider({
    orderData,
    setOrderData,
  });

  

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isLoading) return
    if (orderData) {
      setIsLoading(true);
      setResponse(undefined);
      setLoadingMessage('Saving Order...');

      const requestData = orderData;
      if (requestData.customer)
        requestData.customer.merchant = {
          id: user!.id.toString(),
        } as MerchantType;

      requestData.price = get_price(
        cod,
        requestData.delivery_fee,
        requestData.delivery_fee_covered_by_merchant
      );
      console.log(requestData);

      try {
        let response;
        if (defaultOrder === undefined) {
          // create new
          response = await axios.post<OrderType>(
            `${API_ENDPOINT}/api/v1/orders/`,
            requestData,
            config
          );
          onSuccess && onSuccess(response.data);
          setOrderData(
            updateDeliveryFee(
              {
                ...emptyOrder,
                merchant: orderData.merchant,
                merchant_location: orderData.merchant_location,
              },
              calculateBaseDeliveryFee(orderData)
            )
          );
          setCod([]);
        } else {
          // update existing
          response = await axios.put(
            `${API_ENDPOINT}/api/v1/order/${orderData.id}/`,
            requestData,
            config
          );

          onSuccess && onSuccess(response.data);
        }
        setMessage('Order saved successfully');
        setResponse(response);
      } catch (e) {
        if (axios.isAxiosError(e)) {
          setResponse(e.response);
          setMessage('Failed to save order: ' + e.response?.statusText);
        } else {
          setMessage('Failed to save order');
        }
        console.log(e);
      }
      setIsLoading(false);
      setLoadingMessage('');
    }
  };

  const handleFetchPickupLocations = async (query: string) => {
    if (orderData) {
      const endpoint = `${API_ENDPOINT}/api/v1/pickups/?page_size=10&name__contains=${encodeURIComponent(query)}`;

      try {
        const response = await axios.get<{
          count: number;
          results: ShopLocationType[];
        }>(endpoint, config);
        return response.data.results;
      } catch (error) {
        console.log(error);
      }
    }

    return [];
  };

  const handleFetchCustomerLocations = async (query: string) => {
    if (orderData && orderData.customer != null) {
      const endpoint = `${API_ENDPOINT}/api/v1/locations/?page_size=100&customer=${orderData.customer?.id}&address__contains=${encodeURIComponent(query)}`;

      try {
        const response = await axios.get<{
          count: number;
          results: ILocation[];
        }>(endpoint, config);

        return response.data.results;
      } catch (error) {
        console.log(error);
      }
    }

    return [];
  };

  const shipmentSourceAndDestinationInput = orderData
    ? [
        <Grid
          container
          spacing={2}
          key="customer"
          alignItems="center"
          justifyContent="center"
          sx={{ flexGrow: 1 }}
        >
          {orderData.customer && orderData.customer.id != '' && (
            <>
              <IconButton
                onClick={() =>
                  setCreatingNewCustomerOpenFor(orderData.customer)
                }
              >
                <Edit color="primary" />
              </IconButton>{' '}
              Modify customer data
            </>
          )}
          <Grid xs={12} md={12}>
            <AutocompleteWithThrottle
              label={'Customer'}
              onClickAdd={() => setCreatingNewCustomerOpenFor(emptyCustomer)}
              fetch={handleFetchCustomers}
              value={orderData.customer}
              disabled={!canEditCustomerLocation}
              getOptionLabel={(option: CustomerType) =>
                option.name + ' ' + option.phone_number
              }
              onChange={(e: any, value: CustomerType | null) => {
                assignCustomer(value ?? emptyCustomer);
              }}
            />
          </Grid>
          <Grid xs={12} md={12}>
            <AutocompleteWithThrottle
              label={'Location'}
              fetchAllOnLoad
              disabled={!canEditCustomerLocation}
              value={orderData.customer_location}
              onChange={(e, value) =>
                setOrderData({ ...orderData, customer_location: value })
              }
              fetch={handleFetchCustomerLocations}
              onClickAdd={() => {
                if (orderData.customer == null)
                  alert('Please select customer first');
                else setCreateLocation(true);
              }}
              getOptionLabel={function (option: ILocation): string {
                return displayLocation(option);
              }}
            />
          </Grid>
        </Grid>,
        <Grid container spacing={2} key="merchant">
          <Grid xs={12} md={12}>
            <TextField
              autoComplete="off"
              disabled
              value={user?.name}
              fullWidth
              label="Merchant"
            />
          </Grid>

          <Grid xs={12} md={12}>
            <AutocompleteWithThrottle
              label={'Location'}
              fetchAllOnLoad
              disabled={!canEditMerchantLocation}
              value={orderData.merchant_location}
              onChange={(e, value) =>
                setOrderData({ ...orderData, merchant_location: value })
              }
              fetch={handleFetchPickupLocations}
              onClickAdd={() => {
                setCreatePickupLocation(true);
              }}
              getOptionLabel={function (option: ShopLocationType): string {
                return `${option.name}: ${displayLocation(option)}`;
              }}
            />
          </Grid>
        </Grid>,
      ]
    : [];

  console.log('check cod here: ', cod);

  useEffect(() => {
    if (orderData)
      setOrderData({
        ...orderData,
        frozen_until: frozenUntil ? frozenUntil.toISOString() : undefined,
      });
  }, [frozenUntil]);

  const disableSensitiveFields = (defaultOrder != undefined && ![DeliveryState.CREATED, DeliveryState.PICKUP_REQUESTED, DeliveryState.PICKUP_ASSIGNED, DeliveryState.PICKED_UP].includes(defaultOrder.delivery_state))
  
  
  let appliedRule: IDeliveryChargeRule | undefined = undefined
  
  if (orderData && orderData.delivery_fee_rules)
    appliedRule = orderData.delivery_fee_rules.find((rule) =>
      deliveryChargeRuleApplies(rule, orderData.customer_location)
    );

  const extraChargesDisplayList = orderData ? splitExtraCharges(orderData) : [];

  
  return (
    <>
      <Typography
        variant="h3"
        component="h3"
        sx={{ textAlign: 'center', }}
      >
        {orderData?.id === '' ? 'Create Order' : 'Edit Order'}
      </Typography>

      {
        orderData?.id == '' && <Box sx={{cursor:'pointer', width: "100%", textDecoration: "underline", color: "primary", display: "flex", justifyContent: "center", alignItems: "center", mb: 3 }} onClick={()=>showVideoTutorial("https://www.youtube.com/embed/GO7gm7TBk4g?si=ZL8svuCEgSUlFdoz")}>
            <IconWithText centered> <YouTube color="primary" /> <Typography sx={{color: "primary"}} variant="body1">Learn how to create an order</Typography></IconWithText>
          </Box>
      }

      {isLoading ? (
        <>
          {loadingMessage}
          <br />
          <LinearProgress />
        </>
      ) : (
        <>
          {message !== '' && (
            <Alert
              severity={
                response && response.status >= 200 && response.status < 300
                  ? 'success'
                  : 'error'
              }
            >
              <>
                {message}

                {response && response.status >= 300 && (
                  <ErrorsFlattenner rawErrors={response.data} />
                )}
              </>
            </Alert>
          )}

          {orderData && (
            <>
              <br></br>
              <form onSubmit={handleSubmit}>
                <FormControl fullWidth>
                  <FormLabel id="demo-radio-buttons-group-label">
                    Workflow
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue={workflow}
                    row
                    name="radio-buttons-group"
                    onChange={(e) => {
                      setWorkflow(e.target.value as Workflow);
                      setOrderData({
                        ...orderData,
                        workflow: e.target.value as Workflow,
                      });
                    }}
                  >
                    <FormControlLabel
                      disabled={!canEditWorkflow}
                      value={Workflow.STANDARD}
                      control={<Radio />}
                      label="Standard"
                    />
                    <FormControlLabel
                      disabled={!canEditWorkflow}
                      value={Workflow.RETURN}
                      control={<Radio />}
                      label="Return"
                    />
                  </RadioGroup>
                </FormControl>
                {orderData.workflow === Workflow.RETURN && (
                  <>
                    <br />
                    <br />

                    <FormControl fullWidth sx={{ mb: 2 }}>
                      <TextField
                        autoComplete="off"
                        label="Return Reason"
                        type="text"
                        variant="outlined"
                        multiline
                        value={orderData.return_reason}
                        rows={2}
                        onChange={(e) =>
                          setOrderData({
                            ...orderData,
                            return_reason: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                  </>
                )}
                <br />
                <Checkbox
                  checked={orderData.is_critical}
                  onChange={() =>
                    setOrderData({
                      ...orderData,
                      is_critical: !orderData.is_critical,
                    })
                  }
                />{' '}
                Critical Order ⚠️
                
                {(defaultOrder?.critical_order_surcharge == null) && orderData.is_critical && (
                  <CriticalOrderBalanceDisplay compact={true} balance={balance} loading={loadingBalance} />
                )}
                
                <br />     
                  <IconWithText>  <Checkbox
                    checked={orderData.is_fragile}
                    onChange={() =>
                      setOrderData({
                        ...orderData,
                        is_fragile: !orderData.is_fragile,
                      })
                    }
                  />{' '}Fragile (قابل للكسر)  <GiCrackedGlass size={24} color={color} /></IconWithText>
                  
                {orderData.workflow === Workflow.STANDARD && (
                  <>
                    <Checkbox
                      checked={orderData.is_exchange}
                      onChange={() =>
                        setOrderData({
                          ...orderData,
                          is_exchange: !orderData.is_exchange,
                        })
                      }
                    />{' '}
                    Require Exchange
                  </>
                )}
                <br />
                {defaultOrder == undefined && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        marginBottom: 4,
                      }}
                    >
                      <DatePicker
                        label="Freeze Until"
                        value={frozenUntil}
                        onChange={(newValue) => {
                          setFrozenUntil(newValue);
                        }}
                      />
                      <IconButton onClick={() => setFrozenUntil(null)}>
                        <Backspace color={'primary'} />
                      </IconButton>
                    </div>
                  </LocalizationProvider>
                )}
                <InputWithLegend
                  label={"Order ID's"}
                  icon={<QrCode2Icon color={'primary'} />}
                >
                  <FormControl fullWidth>
                    <Grid container spacing={2}>
                      <Grid xs={12} md={6}>
                        <TextField
                          autoComplete="off"
                          label="ID automatically assigned"
                          type="text"
                          variant="outlined"
                          fullWidth
                          required
                          disabled
                          value={orderData.order_id}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              e.stopPropagation();
                            }
                          }}
                        />
                      </Grid>

                      <Grid xs={12} md={6}>
                        <TextFieldWithScan
                          label="Reference Number"
                          type="text"
                          variant="outlined"
                          fullWidth
                          value={orderData.reference_id}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              e.stopPropagation();
                            }
                          }}
                          act={(value) =>
                            setOrderData({
                              ...orderData,
                              reference_id: value.trim(),
                            })
                          }
                        />
                      </Grid>
                    </Grid>
                  </FormControl>
                </InputWithLegend>
                <br />
                {workflow === Workflow.STANDARD ? (
                  <>
                    <InputWithLegend
                      label={'Ship From'}
                      key="ship-from"
                      icon={<LocalShippingIcon color="primary" />}
                    >
                      {shipmentSourceAndDestinationInput[1]}
                    </InputWithLegend>

                    <br />

                    <InputWithLegend
                      label={'Ship To'}
                      key="ship-to"
                      icon={<LocationOnIcon color="primary" />}
                    >
                      {orderData.workflow == Workflow.STANDARD &&
                        orderData.customer_location &&
                        !orderData.customer_location.area && (
                          <IncompleteAddressError />
                        )}
                      {orderData.workflow == Workflow.RETURN &&
                        orderData.merchant_location &&
                        !orderData.merchant_location.area && (
                          <IncompleteAddressError />
                        )}
                      {shipmentSourceAndDestinationInput[0]}
                      {(orderData.workflow == Workflow.STANDARD && orderData.customer_location && orderData.delivery_fee_rules && appliedRule) && <>
                            <Typography sx={{mt:2}} variant='body1' color='error'> ⚠️ The selected location {new Decimal(appliedRule.delta_charge).isPos() ?  "incurs extra delivery charge" : "benefits from a delivery charge discount"} {` ${appliedRule.delta_charge.toString()} $`}</Typography>
                            {appliedRule.is_deleted ? `[Deleted Rule] ${displayDeliveryRule(appliedRule)}` : <Box sx={{textDecoration: "underline", cursor: "pointer"}} onClick={()=>setExplainDeliveryRule(true)}><b> See why</b></Box>}
                            {
                              explainDeliveryRule  && <DeliveryChargeOverridesDialog 
                                readonly 
                                onClose={()=>setExplainDeliveryRule(false)} merchant={ {
                                  name: user!.name,
                                  phone_number: user!.phone_number,
                                  default_delivery_fee: user!.default_delivery_fee ?? [],
                                } as MerchantType} 
                                defaultFocus={orderData.delivery_fee_rules.find(rule => deliveryChargeRuleApplies(rule, orderData.customer_location!))}/>
                            }
                      </>}
                    </InputWithLegend>
                  </>
                ) : (
                  <>
                    <InputWithLegend
                      label={'Ship From'}
                      key="ship-from"
                      icon={<LocalShippingIcon color="primary" />}
                    >
                      {shipmentSourceAndDestinationInput[0]}
                    </InputWithLegend>

                    <br />

                    <InputWithLegend
                      label={'Ship To'}
                      key="ship-to"
                      icon={<LocationOnIcon color="primary" />}
                    >
                      {shipmentSourceAndDestinationInput[1]}
                    </InputWithLegend>
                  </>
                )}
                <br />
                <MoneyInput
                  money={cod}
                  disabled={disableSensitiveFields}
                  setMoney={(m) => setCod(m)}
                  label={
                    orderData.workflow == Workflow.STANDARD
                      ? 'Collect on Delivery'
                      : 'Return COD'
                  }
                  icon={<MonetizationOnIcon color={'primary'} />}
                />
                <br />
                {orderData.workflow === Workflow.STANDARD && (
                  <>
                    <MoneyInput
                      footer={
                        (isUpdatingDeliveryFees || loadingBalance) ?<Box justifyContent={"center"} display={"flex"} width={"100%"} mt={1}> <CircularProgress size={20} /> </Box>: 
                        calculateExtraDeliveryCharges(orderData).length ==
                        0 ? undefined : (
                          <Alert
                            sx={{ mt: 2, width: '100%' }}
                            severity="warning"
                          >
                            <b>
                              {displayMoney(
                                calculateExtraDeliveryCharges(orderData)
                              )}
                            </b>

                            <Box
                              sx={{
                                width: '100%',
                                display: 'inline',
                                justifyContent: 'flex-start',
                                mt: 0.5,
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setExtraChargesExpanded(
                                    !extraChargesExpanded
                                  );
                                }}
                                sx={{ p: 0 }}
                              >
                                {extraChargesExpanded ? (
                                  <ExpandLess />
                                ) : (
                                  <ExpandMore />
                                )}
                              </IconButton>
                              <Typography variant="caption" sx={{ ml: 0.5 }}>
                                {extraChargesExpanded ? 'Hide' : 'More Details'}
                              </Typography>
                            </Box>

                            <Collapse in={extraChargesExpanded} sx={{ mt: 1 }}>
                               {(orderData.labels || orderData.delivery_fee_rules || isUpdatingDeliveryFees || loadingBalance || orderData.critical_order_surcharge) && (
                                <GenericTable<{id: string; amount: string, reason: JSX.Element}>
                                  sourceView="merchant-create-order-form"
                                  items={extraChargesDisplayList}
                                  selectedItems={new Map()}
                                  getItemUID={(item) => item.id}
                                  columns={[
                                    {
                                      id: 'amount',
                                      header: 'Charge',
                                      display_body: (item) => (
                                        <b>{item.amount}</b>
                                      ),
                                    },
                                    {
                                      id: 'reason',
                                      header: 'Reason',
                                      display_body: (item) => item.reason,
                                    },
                                  ]}
                                  isLoading={isUpdatingDeliveryFees || loadingBalance}
                                />
                              )}
                            </Collapse>
                          </Alert>
                        )
                      }
                      money={calculateBaseDeliveryFee(orderData)}
                      disabled
                      setMoney={(m) =>
                        setOrderData(updateDeliveryFee(orderData, m))
                      }
                      label="Delivery Fee"
                      icon={<MonetizationOnIcon color={'primary'} />}
                    />
                    <br />
                  </>
                )}

                {user?.product_price_enabled && <FormControl fullWidth sx={{mb: 1}}>
                  <TextField
                    value={orderData.product_price}
                    type="number"
                    label="Product Price ($)"
                    onChange={(e)=>setOrderData({...orderData, product_price: e.target.value})}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        'wheel',
                        (e) => e.preventDefault(),
                        { passive: false }
                      )
                    }
                  />
                </FormControl>}

                <PackagesEditor
                  numberOfPackages={orderData.number_of_packages}
                  setNumberOfPackages={(n) =>
                    setOrderData({ ...orderData, number_of_packages: n })
                  }
                  packagesMetadata={orderData.packages_metadata ?? []}
                  setPackagesMetadata={(meta, number_of_packages) =>
                    setOrderData({
                      ...orderData,
                      packages_metadata: meta,
                      number_of_packages,
                    })
                  }
                  disabled={disableSensitiveFields}
                />

                <br />

                <InputWithLegend
                  label={'Additional Information'}
                  key="ship-from"
                  icon={<SpeakerNotesIcon color="primary" />}
                >
                  <Grid xs={12} md={6}>
                    <WeightInput
                      weight={orderData.weight}
                      setWeight={(w) =>
                        setOrderData({ ...orderData, weight: w })
                      }
                    />
                  </Grid>

                  <FormControl fullWidth>
                    <DimensionsInput
                      dimensions={orderData.dimensions}
                      setDimensions={(d) =>
                        setOrderData({ ...orderData, dimensions: d })
                      }
                    />
                  </FormControl>
                </InputWithLegend>
                <br />
                <FormControl fullWidth>
                  <LabelsInput
                    currentlySelectedLabels={orderData.labels ?? []}
                    setCurrentlySelectedLabels={setSelectedLabels}
                  />
                </FormControl>
                <br />
                <br />
                <FormControl fullWidth>
                  <TextFieldWithArabicKeyboard
                    autoComplete="off"
                    label="Note"
                    type="text"
                    variant="outlined"
                    multiline
                    value={orderData.public_note}
                    rows={2}
                    onChange={(v) =>
                      setOrderData({
                        ...orderData,
                        public_note: v
                      })
                    }
                  />
                </FormControl>
                <br />
                <br />
                <Button
                  size={isMobile && !isTablet ? 'small' : 'medium'}
                  type="submit"
                  variant="contained"
                  disabled= {isUpdatingDeliveryFees || isLoading || loadingBalance}
                >
                  Save Order
                </Button>
              </form>
            </>
          )}
        </>
      )}

      <CustomDialog
        fullWidth
        open={createPickupLocation}
        onClose={() => setCreatePickupLocation(false)}
        fullScreen={isMobile && !isTablet}
        maxWidth="md"
      >
        <div
          style={{
            textAlign: 'right',
            width: '100%',
          }}
        >
          <IconButton onClick={() => setCreatePickupLocation(false)}>
            <ClearIcon color="primary" fontSize="large" />
          </IconButton>
        </div>

        <DialogContent>
          <MerchantCreatePickupLocationForm
            successCallback={assignPickupLocation}
          />
        </DialogContent>
      </CustomDialog>

      {creatingNewCustomerOpenFor && (
        <CustomDialog
          fullWidth
          open={creatingNewCustomerOpenFor != null}
          onClose={() => setCreatingNewCustomerOpenFor(null)}
          fullScreen={isMobile && !isTablet}
          maxWidth="md"
        >
          <div
            style={{
              textAlign: 'right',
              width: '100%',
            }}
          >
            <IconButton onClick={() => setCreatingNewCustomerOpenFor(null)}>
              <ClearIcon color="primary" fontSize="large" />
            </IconButton>
          </div>

          <DialogContent>
            <CreateCustomerForm
              successCallback={(c) => {
                assignCustomer(c);
                setCreatingNewCustomerOpenFor(null);
              }}
              defaultCustomerId={creatingNewCustomerOpenFor.id.toString()}
              allowReuseExisting
            />
          </DialogContent>
        </CustomDialog>
      )}

      <CustomDialog
        fullWidth
        open={createLocation}
        onClose={() => setCreateLocation(false)}
        fullScreen={isMobile && !isTablet}
        maxWidth="md"
      >
        <div
          style={{
            textAlign: 'right',
            width: '100%',
          }}
        >
          <IconButton onClick={() => setCreateLocation(false)}>
            <ClearIcon color="primary" fontSize="large" />
          </IconButton>
        </div>

        <DialogContent style={{ overflowY: 'visible' }}>
          {orderData?.customer ? (
            <CreateLocationForm
              customer={orderData?.customer}
              successCallback={assignLocation}
            />
          ) : (
            <Alert severity="error">
              Cannot create location for unknown customer.
            </Alert>
          )}
        </DialogContent>
      </CustomDialog>

     
    </>
  );
}

export default MerchantCreateOrderForm;
